module.exports = "img/0.dce870.webp";